import { cn } from "@/lib/utils/cn";

type ProgressSegment = { percent: number; className: string };

type ProgressProps = {
  segments: ProgressSegment[];
  label: string;
  value?: number;
  className?: string;
};

function Progress({ segments, label, value, className }: ProgressProps) {
  const isMeter = value !== undefined;
  return (
    <div
      role={isMeter ? "progressbar" : "img"}
      aria-label={label}
      aria-valuemin={isMeter ? 0 : undefined}
      aria-valuemax={isMeter ? 100 : undefined}
      aria-valuenow={value}
      data-slot="progress"
      className={cn("flex h-2 w-full gap-0.5 overflow-hidden rounded-full bg-muted", className)}
    >
      {segments
        .filter((segment) => segment.percent > 0)
        .map((segment) => (
          <div
            key={segment.className}
            className={cn("h-full transition-[width] duration-700 ease-out motion-reduce:transition-none", segment.className)}
            style={{ width: `${segment.percent}%` }}
          />
        ))}
    </div>
  );
}

export { Progress };
